import { Input, Modal, Form, Button } from "antd";
import axios from "axios";
import React, { useState, useEffect } from "react";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import DragUpload from "../../../commons/DragUpload/DragUpload";
import { Error, Success } from "../../../commons/Messages/Messages";
import "./SubAdmin.css";

import { useTranslation } from "react-i18next";
const EditSubAdmin = ({ data, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onSubmit = async values => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/users/update-profile/${data?._id}`,
        values,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }
      );
      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        updateParent();
        handleCancel();
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      if (err?.response && err?.response?.data && err?.response?.data?.errors) {
        const validationErrors = err?.response?.data?.errors;
        const errorMessage = Object.values(validationErrors)
          ?.map(err => `${err?.path} is ${err?.kind}.`)
          .join("\n");
        Error(errorMessage);
      } else if (err?.response?.data?.keyPattern) {
        Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
      } else {
        Error(err.message);
      }
    }
  };

  return (
    <div className="EditSubAdmin">
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      <Modal
        destroyOnClose
        title={t("Edit Sub Admin")}
        width={640}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="submit" type="primary" htmlType="submit" form="admin-edit-subadmin">
            {t("Submit")}
          </Button>
        ]}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <Form id="admin-edit-subadmin" form={form} layout="vertical" onFinish={onSubmit}>
          <Form.Item name="picture" label={t("Picture")}>
            <DragUpload
              noMultiple
              updateFiles={val => form.setFieldsValue({ picture: val[0]?.response })}
            />
          </Form.Item>
          <Form.Item
            name="firstName"
            label={t("First Name")}
            rules={[{ required: true, message: t("First name is required") }]}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item name="lastName" label={t("Last Name")}>
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="username"
            label={t("Username")}
            rules={[{ required: true, message: t("Username is required") }]}
          >
            <Input autoComplete="off" autoCapitalize="none" spellCheck={false} />
          </Form.Item>
          <Form.Item
            name="email"
            label={t("Email")}
            rules={[{ required: true, type: "email", message: t("Valid email is required") }]}
          >
            <Input type="email" inputMode="email" autoComplete="off" />
          </Form.Item>
          <Form.Item name="password" label={t("Password")}>
            <Input.Password disabled />
          </Form.Item>
          <Form.Item name="confirm" label={t("Confirm Password")}>
            <Input.Password disabled />
          </Form.Item>
          <Form.Item name="phone" label={t("Phone")}>
            <Input type="tel" inputMode="tel" autoComplete="off" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EditSubAdmin;
